import React, { useContext, useState } from "react"
import { CircularProgress, Tooltip, Zoom } from "@mui/material"
import { ContentCopy, ExpandLess, ExpandMore, InfoOutlined, KeyboardBackspaceOutlined, Videocam } from "@mui/icons-material"
import { WtTheme } from "../../controller/theme"
import { MultiPurposeDialog } from "../../controller/BaseTool"
import { Button, Col, Collapse, Container, Form, InputGroup, Row } from "react-bootstrap"
import { initializeApp } from "firebase/app"
import { getDatabase, onChildChanged, ref } from "firebase/database"
import { SideMenu } from "./SideMenu"
import globalContext from "../../context/global/globalContext"
import { WtColor } from "../../constants/colours"
import GSheetState from "../../context/googleSheetInt/gSheetState"
import gSheetContext from "../../context/googleSheetInt/gSheetContext"
import { Env } from "../../controller/constant"
import { useEffect } from "react"
import { getLoggedUserInfo } from "../../basetool/methods"
import { WtLoginKey } from "../../constants/loginKeys"

const app = initializeApp(Env.firebaseConfig)
const db = getDatabase(app)
var firesocketBusinessId = getLoggedUserInfo(WtLoginKey.businessId)

export const AppIntegration = () => {
  return (
    <GSheetState>
      <AppIntegrationApp />
    </GSheetState>
  )
}

export const AppIntegrationApp = () => {
  const notificationBarStatus = useContext(globalContext)
  const [appIntegUI, setAppIntegUI] = useState("home")
  const handleAppIntegUI = (ui) => setAppIntegUI(ui)


  const AppIntegrationSchema = [
    {
      img: "https://raw.githubusercontent.com/love-building-app/letsserve/master/prod/home/WTB/google.png",
      desc: "Integrate Spreed Sheet",
      type: "Google Sheet Platform",
      status: "Setup now",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/shopify.png",
      desc: "Chat Widget, Cart Abandonment Emails, etc.",
      type: "E-commerce Platform",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/whatsapp_link_generate_icon.png",
      desc: "Create shareable links & QR  for your WA business number",
      type: "Messaging Platform",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/zapier_icon.png",
      desc: "Send an approved template WhatsApp message",
      type: "Connect Platform",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/woo_commerce_icon.png",
      desc: "Chat Widget, Cart Abandonment Emails, etc.",
      type: "E-commerce Platform",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/hubspot_icon.png",
      desc: "Integrate messages on the Hubspot CRM",
      type: "CRM Platform",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/pabbly_icon.png",
      desc: "Automate or link with 700+ apps throgh pabbly Connect",
      type: "Online Marketing & Sales Platform",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
    {
      img: WtTheme.ImageBaseUrl + "/razorpay_icon.png",
      desc: "Integrate messages on the Razorpay",
      type: "Payment Provider",
      status: "coming soon",
      activityKey: "googleSheetApp",
    },
  ]

  const profile_base_view = { display: "flex", backgroundColor: "#f8f8f8", height: notificationBarStatus.notificationBarStatus ? "90vh" : "98vh", width: "94vw" }
  const profile_menu_item = { flex: "0.85" }

  const [openMultiPurposeDialog, setOpenMultiPurposeDialog] = useState({ open: false, onClose: null })
  const openMultiPurposeDialogBox = (purposeVal, demandVal, reqData) => setOpenMultiPurposeDialog({ open: true, purposeVal: purposeVal, demandVal: demandVal, reqData: reqData, onClose: async () => setOpenMultiPurposeDialog(false) })
  return (
    <div style={profile_base_view}>
      <SideMenu />
      <div style={profile_menu_item} className="bg-white">
        {appIntegUI === "home" && <AppIntegHome uiSchema={AppIntegrationSchema} handleAppIntegUI={handleAppIntegUI} />}
        {appIntegUI === "googleSheetApp" && <GoogleSheetApp openMultiPurposeDialog={openMultiPurposeDialog} openMultiPurposeDialogBox={openMultiPurposeDialogBox} />}
      </div>
    </div>
  )
}

export const AppIntegHome = ({ uiSchema, handleAppIntegUI }) => {
  return (
    <div>
      <div className="border-bottom ps-3 pt-2 pb-1 pe-5" style={{ display: "flex" }}>
        <div style={{ flex: 1, paddingTop: "4px" }}>
          <h5 style={{ color: WtColor.TextDarkColor }}>
            APP Integration &nbsp;
            <Tooltip
              title="Application integration is the process of enabling independently designed applications to work together. Commonly required capabilities include: Keeping separate copies of data (in independently designed applications) consistent."
              placement="bottom-start"
              TransitionComponent={Zoom}
              TransitionProps={{ timeout: 600 }}
            >
              <InfoOutlined
                style={{
                  color: WtColor.TextLightGrey,
                  marginTop: "-5px",
                  fontSize: "15px",
                }}
              />
            </Tooltip>
          </h5>
          <p
            style={{
              fontSize: "10px",
              color: WtColor.TextLightGrey,
              marginTop: "-6px",
              marginBottom: "0px",
            }}
          >
            Connect WhatsTool Business to your favorite services
          </p>
        </div>
      </div>
      <div className="mt-2 ps-2">
        <Container className="app_list" style={{ height: "610px" }} fluid>
          <Row>
            {uiSchema?.map((v, i) => {
              return (
                <Col
                  xxl={3}
                  xl={3}
                  lg={3}
                  md={3}
                  sm={3} xs={3} key={i} className="mt-1 mb-3 hand">
                  <div
                    className=" p-3"
                    style={{
                      borderRadius: "6px",
                      boxShadow: "0px 0px 8px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <img
                        src={v.img}
                        alt={WtTheme.SiteName}
                        className="img-fluid"
                        style={{ height: "35px" }}
                      />
                      <div style={{ flex: "1" }}>&nbsp;</div>
                      <div>
                        <button
                          onClick={() => handleAppIntegUI(v.activityKey)}
                          className="btn btn-sm text-white "
                          style={{
                            background: WtColor.BaseLightColor,
                            borderRadius: "30px",
                            paddingTop: "1px",
                            paddingBottom: "1px",
                            paddingLeft: "8px",
                            paddingRight: "8px",
                          }}
                        >
                          {v.status}
                        </button>
                      </div>
                    </div>
                    <p style={{ color: WtColor.TextLightGrey }}>{v.type}</p>
                    <p style={{ color: WtColor.TextDarkColor }}>{v.desc}</p>
                  </div>
                </Col>
              )
            })}
          </Row>
        </Container>
      </div>
    </div>
  )
}

export const GoogleSheetApp = ({ openMultiPurposeDialog, openMultiPurposeDialogBox, getSheetcallback }) => {
  const isSelectTemplate = useContext(gSheetContext)
  const templateData = useContext(gSheetContext)
  const updateuserGSheetData = useContext(gSheetContext)
  const getResponseData = useContext(gSheetContext)
  const googleSheetGetData = useContext(gSheetContext)
  const setCookie = useContext(gSheetContext)
  const [isShowprogress, setIsShowprogress] = useState(true)
  const [isShowResponse, setIsShowResponse] = useState(false)

  const [sheetId, setSheetId] = useState(undefined)
  const [sheetName, setSheetName] = useState(undefined)
  const [keyList, setKeyList] = useState([])
  const [valuesList, setvaluesList] = useState([])
  const [selectKey, setSelectKey] = React.useState([])

  const copyToClipboard = (evt) => {
    navigator.clipboard.writeText(evt)
  }
  const handleResponseShow = () => {
    isShowResponse ? setIsShowResponse(false) : setIsShowResponse(true)
  }
  const webhookUrls = "/app/gsheet/webhook/"
  const G_SheetWebhookUrl = Env.baseApiCallURL + webhookUrls + getLoggedUserInfo(WtLoginKey.businessId)

  const handleKeyChange = (event) => {
    console.log("Key: ", event.target.value + ", " + event.target.id)
    setSelectKey((datas) => ({
      ...datas,
      [event.target.id]: event.target.value,
    }))

    console.log("Key1: ", event.target.value + ", " + JSON.stringify(selectKey),)
  }

  const handleSaveData = () => {
    const data = {
      templateName: templateData.templateData[0]?.temp?.name,
      templateLang: templateData.templateData[0]?.temp?.language,
      headerLink: templateData.templateData[0]?.mediaLink || undefined,
      headerType: templateData.templateData[0]?.mediaType || undefined,
      channelId: localStorage.getItem("c1"),
      variableKeys: selectKey,
      sheetId: sheetId,
      sheetName: sheetName,
    }
    const responseData = updateuserGSheetData.updateuserGSheetData(data)
    console.log("responseData: ", responseData)
    console.log("handleSaveData: ", JSON.stringify(selectKey))
  }

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noopener,noreferrer")
  }
  function getRefence() {
    const refs = ref(db, "/wtx-ext-apps-noti/" + firesocketBusinessId)
    return refs
  }
  const refrence = getRefence()
  onChildChanged(refrence, (snapshot) => {
    _getGSheetWebhookValue(snapshot.val())
  })

  const _getGSheetWebhookValue = (val) => {
    if (val) {
      setCookie.setCookie("G_SheetResponse", JSON.stringify(val), 365)
      setSheetId(val?.sheetId)
      setSheetName(val?.sheetName)
      console.log("sheetId: " + val?.sheetId)
      const objectkeys = (Object.keys(val))
      const objectsValues = (Object.values(val))
      setIsShowprogress(false)
      setKeyList(objectkeys)
      setvaluesList(objectsValues)
    }
  }
  const _checkData = () => {
    const pairs = document.cookie.split("")
    console.log("pairs: " + pairs)
    if (pairs) {
      let cData
      pairs.forEach((e) => {
        const v = e.trim()
        console.log("e", v.startsWith("G_SheetResponse"))
        if (v.startsWith("G_SheetResponse")) {
          cData = JSON.parse(e.split("=")[1])
          console.log("G_SheetResponse: ", cData)
        }
      })

      if (cData) {
        const objectkeys = (Object.keys(cData))
        const objectsValues = (Object.values(cData))
        setKeyList(objectkeys)
        setvaluesList(objectsValues)
      }
      setIsShowprogress(false)
    }
  }

  useEffect(() => {
    googleSheetGetData.googleSheetGetData()
    _checkData()
  })

  return (
    <div>
      <row xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
        <div>
          <div
            className="border-bottom ps-3 pt-2 pb-1 pe-5"
            style={{ display: "flex" }}
          >
            <div style={{ display: "flex", paddingTop: "4px" }}>
              <KeyboardBackspaceOutlined onClick={() => AppIntegration()}>
                Back
              </KeyboardBackspaceOutlined>
              <h5 style={{ color: WtColor.TextDarkColor, marginLeft: "10px" }}>
                Google Sheet App
              </h5>
            </div>
          </div>
          <div
            style={{ marginLeft: "20px", marginTop: "10px", display: "flex" }}
          >
            <img
              src="https://raw.githubusercontent.com/love-building-app/letsserve/master/prod/home/WTB/google.png"
              alt={WtTheme.SiteName}
              className="img-fluid"
              style={{ height: "35px" }}
            />
            <p style={{ marginTop: "5px" }}>Trigger Event</p>

            <p
              className="rounded-2 hand"
              id="tooltip-freeTask"
              style={{
                height: "18px",
                marginLeft: "15px",
                marginTop: "9px",
                fontSize: "9px",
                paddingLeft: "5px",
                paddingRight: "5px",
                paddingTop: "2px",
                backgroundColor: WtColor.veryLiteGreen,
                color: WtColor.LiteGreen,
              }}
            >
              Free Task
            </p>

            <Videocam
              className="hand"
              style={{ marginLeft: "15px", marginTop: "6px", width: "15px" }}
            >
              <Tooltip
                title="Application integration is the process of enabling independently designed applications to work together. Commonly required capabilities include: Keeping separate copies of data (in independently designed applications) consistent."
                placement="bottom-start"
                TransitionComponent={Zoom}
                TransitionProps={{ timeout: 600 }}
              >
                <InfoOutlined
                  style={{
                    color: WtColor.TextLightGrey,
                    marginTop: "-5px",
                    fontSize: "15px",
                  }}
                />
              </Tooltip>
            </Videocam>
          </div>
          <div
            className="p-3 rounded-3"
            style={{
              marginLeft: "20px",
              border: "1px solid " + WtColor.LineColor,
            }}
          >
            <Form.Label
              htmlFor="webhook_url"
              className="fw-bold"
              style={{ color: WtColor.TextMidGrey }}
            >
              Webhook URL
            </Form.Label>
            <InputGroup className="mb-3">
              <Form.Control
                defaultValue={G_SheetWebhookUrl}
                value={G_SheetWebhookUrl}
                id="webhook_url"
                placeholder={G_SheetWebhookUrl}
              />
              <Tooltip title="Copy to Clipboard" placement="bottom">
                <InputGroup.Text
                  id="copy_to_clipboard"
                  style={{
                    background: WtColor.LineColor,
                    color: WtColor.TextMidGrey,
                  }}
                  className="hand"
                >
                  <ContentCopy
                    onClick={() => copyToClipboard(G_SheetWebhookUrl)}
                  />
                </InputGroup.Text>
              </Tooltip>
            </InputGroup>

            <h5>Follow below steps -</h5>
            <p>
              ● Make sure you're logged into single Google Sheets account while
              doing the setup.
            </p>
            <p>
              ● Create a new Spreadsheet. Navigate to the{" "}
              <strong>Extensions</strong>, move to{" "}
              <strong>Add-ons</strong> option and then click on{" "}
              <strong>Get add-ons</strong>.
            </p>
            <p>
              ● A dialog box will appear. Now search for the WhatsTool Business
              Webhook add-on, install it, and refresh the page once.
            </p>
            <p>
              ● Navigate to the <strong>Extensions</strong>{" "}
              menu again, and click on WTB Webhook.
            </p>
            <p>
              ● That's it. You have successfully set up the webhook in your
              Google Sheets as a trigger.
            </p>
            <p>
              ● If you are manually making the change in the Spreadsheet, the
              updated data will be sent immediately to WhatsTool Business.
              Ensure enabling the Send on Event option in the addon.
            </p>
            <p>
              ● If the change is made through an external plaform besides Google
              Forms in the Spreadsheet, the trigger will be sent once every one
              hour. Ensure you enable the Send on Schedule option in the addon.
            </p>
            <p>
              ● <strong>Notes:</strong> Column should be include whatsapp.
            </p>
            {/* <p>● Guide Link</p> */}
            <p
              className="hand"
              onClick={() =>
                openInNewTab("https://docs.google.com/spreadsheets")}
            >
              ● <font color="skyblue">Open Google Spreadsheets</font>
            </p>

            <div
              className="hand"
              style={{ display: "flex" }}
              onClick={() => handleResponseShow()}
            >
              {isShowResponse
                ? <ExpandLess></ExpandLess>
                : <ExpandMore></ExpandMore>}

              <p>Response Received</p>
              {isShowprogress && (
                <CircularProgress
                  size="20px"
                  style={{ marginLeft: "10px", marginTop: "3px" }}
                />
              )}
            </div>


            <Container>
              <Collapse in={isShowResponse}>
                <div>
                  <div style={{ marginLeft: "10px", display: "flex" }}>
                    <Col>
                      <p>
                        <strong>Headers:</strong>
                      </p>
                      {keyList?.map((key) => (
                        <div
                          className="mb-3 p2 rounded-2"
                          style={{
                            marginRight: "60px",
                            border: "1px solid " + WtColor.LineColor,
                          }}
                        >
                          <p style={{ margin: "5px" }}>{key}</p>
                        </div>
                      ))}
                    </Col>
                    <Col>
                      <p>
                        <strong>Value:</strong>
                      </p>

                      {valuesList?.map((key) => (
                        <div
                          className="mb-3 p2 rounded-2"
                          style={{
                            marginRight: "60px",
                            border: "1px solid " + WtColor.LineColor,
                          }}
                        >
                          <p style={{ margin: "5px" }}>{key}</p>
                        </div>
                      ))}
                    </Col>
                  </div>
                </div>
              </Collapse>
              {
                /* {isSelectTemplate.isSelectTemplate && (
                <Button>Send Test Message</Button>
              )} */
              }
            </Container>

            {keyList.length > 0 && (
              <><strong>Action:</strong><div
                style={{
                  marginLeft: "10px",
                  marginTop: "5px",
                  marginBottom: "10px",
                  display: "flex",
                }}
              >
                <input
                  type="submit"
                  value="Select Template"
                  class="button rounded-2"
                  onClick={() => openMultiPurposeDialogBox(
                    "G_Sheet",
                    "template",
                    "+" + localStorage.getItem("activeChatWhatsApp")
                  )}
                  style={{ width: "12rem", marginRight: "3rem" }} />
                <Container>
                  {isSelectTemplate.isSelectTemplate && (
                    <div style={{ display: "flex" }}>
                      <strong>Template name:</strong>
                      <font style={{ marginLeft: "5px" }} color="#008000">
                        {templateData.templateData &&
                          templateData.templateData[0]?.temp?.name}
                      </font>
                    </div>
                  )}
                  {!isSelectTemplate.isSelectTemplate &&
                    getResponseData?.getResponseData?.data?.data?.appData
                      ?.templateName &&
                    (
                      <div style={{ display: "flex" }}>
                        <strong>Template name:</strong>
                        <font style={{ marginLeft: "5px" }} color="#008000">
                          {getResponseData?.getResponseData?.data?.data?.appData
                            ?.templateName &&
                            getResponseData?.getResponseData?.data?.data?.appData
                              ?.templateName}
                        </font>
                      </div>
                    )}
                </Container>

                {
                  /* <strong>
                  <Checkbox
                    label="Auto Send Message"
                    value={checked}
                    onChange={handleChange}
                  />
                </strong> */
                }
              </div></>)}

            {/* manual select template */}
            {templateData.templateData &&
              templateData.templateData[0]?.defaultVar && (
                <p style={{ marginLeft: "10px" }}>Set Variables:</p>
              )}
            {/* save select template */}
            {!isSelectTemplate.isSelectTemplate &&
              getResponseData?.getResponseData?.data?.data?.appData
                ?.templateName &&
              <p style={{ marginLeft: "10px" }}>Set Variables:</p>}

            <div style={{ marginLeft: "10px" }}>
              {/* manual select template  */}
              {templateData.templateData &&
                templateData.templateData[0]?.defaultVar &&
                templateData.templateData[0]?.defaultVar
                  .split("|")
                  .map((_v, i) => (
                    <div style={{ display: "flex" }}>
                      <Row>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                          <p>Variable-{i + 1}</p>
                        </Col>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={7} xs={7}>
                          <select
                            style={{ paddingLeft: "4px", width: "9rem" }}
                            id={i}
                            value={selectKey[i]}
                            onChange={handleKeyChange}
                          >
                            <option value="0">Select</option>
                            {keyList &&
                              keyList.map((option, j) => (
                                <option key={j} value={option}>
                                  {option}
                                </option>
                              ))}
                          </select>
                        </Col>
                      </Row>
                    </div>
                  ))}
              {/* save select template */}
              {!isSelectTemplate.isSelectTemplate &&
                getResponseData?.getResponseData?.data?.data?.appData
                  ?.variableKeys &&
                getResponseData?.getResponseData?.data?.data?.appData
                  ?.variableKeys
                  .map((_v, i) => (
                    <div style={{ display: "flex" }}>
                      <Row>
                        <Col xxl={5} xl={5} lg={5} md={5} sm={5} xs={5}>
                          <p>Variable-{i + 1}</p>
                        </Col>
                        <Col xxl={7} xl={7} lg={7} md={7} sm={7} xs={7}>
                          {
                            /* <input
                              type="text"
                              required
                              style={{ paddingLeft: "4px" }}
                            /> */
                          }

                          <select
                            style={{ paddingLeft: "4px", width: "9rem" }}
                            id={i}
                            value={selectKey[i]}
                            onChange={handleKeyChange}
                          >
                            {templateData.templateData && (
                              <option value="0">Select</option>
                            )}
                            {getResponseData?.getResponseData?.data?.data
                              ?.appData
                              ?.variableKeys && (
                                <option value="0">
                                  {getResponseData?.getResponseData?.data?.data
                                    ?.appData
                                    ?.variableKeys[i]}
                                </option>
                              )}
                            {keyList &&
                              keyList.map((option, j) => (
                                <option key={j} value={option}>
                                  {option}
                                </option>
                              ))}
                          </select>
                        </Col>
                      </Row>
                    </div>
                  ))}
            </div>

            {isSelectTemplate.isSelectTemplate && (
              <Button
                style={{
                  marginBottom: "10px",
                  marginLeft: "10px",
                  backgroundColor: "#008000",
                }}
                onClick={handleSaveData}
              >
                Save Template and variables
              </Button>
            )}

          </div>

          {openMultiPurposeDialog?.open
            ? (
              <MultiPurposeDialog
                open={openMultiPurposeDialog.open}
                purposeVal={openMultiPurposeDialog.purposeVal}
                demandVal={openMultiPurposeDialog.demandVal}
                reqData={openMultiPurposeDialog.reqData}
                onClose={openMultiPurposeDialog.onClose}
                getSheetcallback={getSheetcallback}
              />
            )
            : (
              ""
            )}
        </div>
      </row>
    </div>
  )
}
